import { customTV } from '../../utils/tailwind';
export const svgItems = customTV({
    base: [
        'svg-children:fill-content-default',
        'svg-children:stroke-content-default',
        'dark:svg-children:fill-content-default-dark',
        'dark:svg-children:stroke-content-default-dark',
    ],
});
export const icon = customTV({
    base: 'flex items-center justify-center',
    variants: {
        size: {
            64: '[&>svg]:size-64',
            56: '[&>svg]:size-56',
            48: '[&>svg]:size-48',
            40: '[&>svg]:size-40',
            32: '[&>svg]:size-32',
            28: '[&>svg]:size-28',
            24: '[&>svg]:size-24',
            20: '[&>svg]:size-20',
            16: '[&>svg]:size-16',
            14: '[&>svg]:size-14',
            12: '[&>svg]:size-12',
            10: '[&>svg]:size-10',
            8: '[&>svg]:size-8',
        },
    },
});
